import {
  Button,
  Icon,
  Modal,
  ModalOverlay,
  useDisclosure,
} from "@chakra-ui/react";
import { MdAllInbox } from "react-icons/md";
import BrandEmailAddressesModalContent from "./BrandEmailAddressesModalContent";

export default function BrandEmailAddressesModal() {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Button
        onClick={onOpen}
        variant="ghost"
        colorScheme="lightPinkButton"
        size="xs"
        leftIcon={<Icon as={MdAllInbox} />}
        textTransform="none"
      >
        Account email addresses…
      </Button>

      <Modal isOpen={isOpen} onClose={onClose} size="lg">
        <ModalOverlay />
        <BrandEmailAddressesModalContent heading="Account Email Addresses" />
      </Modal>
    </>
  );
}
